import { STORAGE_KEYS } from 'app/constants/storage.constant';
import { currentStoreIdSelector, selectStores, selectStoresEntities } from 'app/main/apps/stores/ducks/stores.selector';
import { actions } from 'app/main/apps/stores/ducks/stores.slice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useStores = () => {
  const dispatch = useDispatch();
  const stores = useSelector(selectStores);
  const storesEntities = useSelector(selectStoresEntities);
  const currentStoreId = useSelector(currentStoreIdSelector);
  const currentStore = currentStoreId ? storesEntities[currentStoreId] : null;

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation_todo>
  useEffect(() => {
    if ((!currentStoreId || !currentStore) && stores.length > 0) {
      updateCurrentStoreId(stores[0].id);
    }
  }, [currentStoreId, stores]);

  const updateCurrentStoreId = (storeId: string) => {
    localStorage.setItem(STORAGE_KEYS.CURRENT_STORE_ID, storeId);
    localStorage.removeItem(STORAGE_KEYS.SELECTED_TAG_ID);
    dispatch(actions.setCurrentStoreId(storeId));
  };

  return {
    stores,
    currentStoreId,
    initialStoreId: currentStoreId,
    currentStore,
    setSelectedStoreId: updateCurrentStoreId,
  };
};
